<template>
  <div v-if="instructor" class="instructor">
    <div
      @click="$emit('searchInstructor', instructor.name)"
      class="instructor__profile-wrapper"
    >
      <img
        class="instructor__profile"
        :src="$getInstructorImg(instructor.profile_img_url)"
        :alt="`INE Instructor ${instructor.name}`"
      />
    </div>
    <div class="instructor__name">
      <p class="lead">INSTRUCTOR</p>
      <p class="instructor__full-name" itemprop="author">
        {{ instructor.name }}
      </p>
    </div>
    <div v-if="instructor.certifications.length" class="instructor__certs">
      <p class="lead">CERTIFICATIONS</p>
      <p
        @click="
          instructor.certifications.length >= 4 ? (showFullCerts = true) : null
        "
        :class="[
          'data',
          instructor.certifications.length >= 4 && 'instructor__pointer',
        ]"
      >
        {{ certifications.join(', ') | limitCerts }}
      </p>
      <p
        v-if="showFullCerts"
        @click="showFullCerts = false"
        class="instructor__full-certs"
      >
        {{ certifications.join(', ') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instructor',
  props: {
    instructor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showFullCerts: false,
    }
  },
  computed: {
    certifications() {
      const { certifications } = this.instructor
      return [certifications.map(cert => cert.name)]
    },
  },
  filters: {
    limitCerts(value) {
      if (value && value.length > 45) {
        return `${value.substr(0, 45)}...`
      }
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
.instructor {
  $this: &;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: var(--dark-gray);
  padding: 0 15px 50px 15px;
  min-height: 117px;
  width: 100%;
  @include mobile {
    width: 60%;
  }
  @include tablet {
    justify-content: flex-start;
  }
  @include desktop {
    padding: 0 20px 0 50px;
  }
  &__profile-wrapper {
    width: 110px;
    margin: 0 25px 0 0;
    &:hover {
      cursor: pointer;
    }
    @include mobile {
      width: 170px;
    }
  }
  &__profile {
    border-radius: 100%;
    width: 100px;
    margin: 0 0 0 10px;
    @include mobile {
      margin: -50px 0 0 0;
      width: 170px;
      max-height: 170px;
    }
  }
  &__name {
    padding: 40px 0 0 0;
    margin: 0 50px 0 0;
  }
  &__full-name {
    color: var(--white);
    margin: 0;
    padding: 0;
    font-weight: 700;
    font-size: 16px;
    font-family: var(--font-bold);
    @include desktop {
      font-size: 22px;
    }
  }
  &__certs {
    padding: 40px 0 0 0;
    max-width: 200px;
    position: relative;
  }
  &__pointer {
    cursor: pointer;
  }
  &__full-certs {
    position: absolute;
    top: 60px;
    z-index: 1;
    color: var(--white);
    background-color: var(--dark-gray);
    font-size: 1rem;
    font-family: var(--font-bold);
    min-height: 150px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
